export const buildFleetMonitorVehicleUrl = (baseUrl: string, vehicleAssetId: string) => {
    const normalizedBaseUrl = baseUrl.replace(/\/$/u, '');
    const encodedVehicleAssetId = encodeURIComponent(vehicleAssetId);

    return `${normalizedBaseUrl}/#/map/${encodedVehicleAssetId}?assetIds=${encodedVehicleAssetId}&tabId=9`;
};
